import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthContext, AuthProvider } from "./context/AuthContext";

// Screens
import LoginScreen from "./screens/Login";
import RegisterScreen from "./screens/Register";
import SelectionScreen from "./screens/Selection";
import HomeScreen from "./screens/Home";
import ProfileScreen from "./screens/Profile";

function AppRoutes() {
  const { user } = useContext(AuthContext);

  return (
    <Routes>
      <Route path="/prijava" element={!user ? <LoginScreen /> : <Navigate to="/izbira" />} />
      <Route path="/registracija" element={!user ? <RegisterScreen /> : <Navigate to="/izbira" />} />
      <Route path="/izbira" element={user ? <SelectionScreen /> : <Navigate to="/prijava" />} />
      <Route path="/domov" element={user ? <HomeScreen /> : <Navigate to="/prijava" />} />
      <Route path="/profil" element={user ? <ProfileScreen /> : <Navigate to="/prijava" />} />
      <Route path="*" element={<Navigate to={user ? "/izbira" : "/prijava"} />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}